module.exports = __webpack_public_path__ + "static/media/order.cab7b390.svg";